module.exports = __webpack_public_path__ + "img/06.ff835d3e.png";